export const THEME_COLORS = {
  dark: {
    bg: '#091318',
    bgSoft: '#0f1b22',
    card: '#12232c',
    border: '#223845',
    text: '#e7f0f5',
    muted: '#8aa2b2',
    accent: '#0ea5a6',
    green: '#22c55e',
    red: '#ef4444',
    yellow: '#f59e0b',
    cyan: '#22d3ee',
    indigo: '#38bdf8',
    shadow: '0 10px 30px rgba(0, 0, 0, 0.22)',
  },
  light: {
    bg: '#edf5f8',
    bgSoft: '#dceaf0',
    card: '#ffffff',
    border: '#c7d8e0',
    text: '#11212b',
    muted: '#58707e',
    accent: '#0f8f97',
    green: '#15803d',
    red: '#dc2626',
    yellow: '#b45309',
    cyan: '#0891b2',
    indigo: '#2563eb',
    shadow: '0 12px 30px rgba(15, 35, 48, 0.08)',
  },
};

export function getThemeTokens(themeMode) {
  const COLORS = THEME_COLORS[themeMode] || THEME_COLORS.dark;
  const th = {
    padding: '9px 12px',
    textAlign: 'left',
    fontSize: '11px',
    fontWeight: '700',
    color: COLORS.muted,
    borderBottom: `1px solid ${COLORS.border}`,
    letterSpacing: '0.03em',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  };
  const td = {
    padding: '9px 12px',
    fontSize: '13px',
    color: COLORS.text,
    borderBottom: `1px solid ${COLORS.border}`,
    whiteSpace: 'nowrap',
  };
  const inputStyle = {
    width: '100%',
    padding: '8px 11px',
    borderRadius: '10px',
    border: `1px solid ${COLORS.border}`,
    background: themeMode === 'light' ? '#ffffff' : '#d7e3e8',
    color: '#0f172a',
    colorScheme: 'light',
    fontSize: '14px',
    outline: 'none',
    marginBottom: '12px',
    boxSizing: 'border-box',
  };
  return { COLORS, th, td, inputStyle };
}
